import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Link from '@material-ui/core/Link';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';


export default function integrationForm(props){

    return(
        <div style={{marginTop:"35px"}}>
            <Popover
                id="popup_copy"
                open={props.store.is_show_popup_copy}
                anchorEl={props.store.anchor_popup}                
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                    }}
                    transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                    }}
            >
                <div style={{padding:"10px"}}>{props.store.copy_ready_text}</div>
            </Popover>
            <Grid container spacing={0} style={{marginTop:"35px"}}>
                <Grid item xs={12}  style={{display:"flex", justifyContent:"center"}}>
                    <TextField
                        id="token_text"
                        label={props.store.token_field_descr_text}
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={props.store.token}
                        onChange={(obj)=>{props.action.changeToken(obj.currentTarget.value)}}
                        InputProps={{
                            endAdornment: props.store.is_token_saved? null: <GroupBtnToken {...props} />,
                            }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={0} style={{marginTop:"35px"}}>

                <Grid item xs={7}>
                    <TextField spacing={0}
                        id="url_text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={props.store.url_field}
                        label={props.store.url_field_descr_text}
                        onChange={(obj)=>{props.action.changeInputUrl(obj.currentTarget.value)}}
                        InputProps={{
                            endAdornment: props.store.is_url_saved? null: <GroupBtnUrl {...props} />,
                            }}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid
                   item xs={2} 
                    style={{display:"flex", justifyContent:"right"}}>
                    <FormControlLabel
                        control={
                                <Switch
                                    disabled={(props.store.url_field_saved!="" && props.store.token_saved!="" && props.store.is_token_saved && props.store.is_toggle_integration_enable && props.store.is_url_saved)? false: true}
                                    checked={props.store.is_integration}
                                    onChange={ ()=>{props.action.changeIntegration(!props.store.is_integration, props.store.app_id)} }
                                    value="checkedB"
                                    color="primary"
                                    size="medium"
                                />
                        }
                        label={props.store.toggle_integration_text}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

function GroupBtnToken(props){
    return(
        <ButtonGroup>
            <Button 
                color="primary" 
                size="medium" 
                style={{width:"110px"}} 
                variant="text" 
                onClick={props.action.cancelToken}>
                    {props.store.token_cancel_btn_text}
            </Button>

            <Button 
                color="primary" 
                size="medium" 
                style={{width:"140px"}} 
                variant="text" 
                onClick={()=>{props.action.saveToken(props.store.token, props.store.app_id)}}>
                    {props.store.token_save_btn_text}
            </Button>
        </ButtonGroup>
    )
}

function GroupBtnUrl(props){
    return(
        <ButtonGroup>
            <Button 
                color="primary" 
                size="medium" 
                style={{width:"110px"}} 
                variant="text" 
                onClick={props.action.cancelUrl}>
                    {props.store.token_cancel_btn_text}
            </Button>

            <Button 
                color="primary" 
                size="medium" 
                style={{width:"140px"}} 
                variant="text"
                onClick={()=>{props.action.saveUrl(props.store.url_field, props.store.app_id)}}>
                    {props.store.token_save_btn_text}
            </Button>
        </ButtonGroup>
    )
}